var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.55C5.88432 8.55 5.29385 8.31295 4.8585 7.89099C4.42315 7.46903 4.17857 6.89674 4.17857 6.3C4.17857 5.70326 4.42315 5.13097 4.8585 4.70901C5.29385 4.28705 5.88432 4.05 6.5 4.05C7.11568 4.05 7.70615 4.28705 8.1415 4.70901C8.57685 5.13097 8.82143 5.70326 8.82143 6.3C8.82143 6.59547 8.76138 6.88806 8.64472 7.16104C8.52806 7.43402 8.35706 7.68206 8.1415 7.89099C7.92593 8.09992 7.67002 8.26566 7.38837 8.37873C7.10672 8.4918 6.80485 8.55 6.5 8.55ZM6.5 0C4.77609 0 3.12279 0.663748 1.90381 1.84523C0.684819 3.02671 0 4.62914 0 6.3C0 11.025 6.5 18 6.5 18C6.5 18 13 11.025 13 6.3C13 4.62914 12.3152 3.02671 11.0962 1.84523C9.87721 0.663748 8.22391 0 6.5 0Z",
    fill: "#F3DE8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.272be003a4b9931466c0dfd94b4c1728.svg";
export { ForwardRef as ReactComponent };